"use client";

import { cn } from "@acme/utils";
import * as ToolbarPrimitive from "@radix-ui/react-toolbar";
import * as React from "react";

const ToolbarRoot = ToolbarPrimitive.Root;

const ToolbarSeparator = ToolbarPrimitive.Separator;

const ToolbarToggleGroup = ToolbarPrimitive.ToggleGroup;

const ToolbarToggleItem = ToolbarPrimitive.ToggleItem;

function Toolbar({
  className,
  ...props
}: React.ComponentProps<typeof ToolbarPrimitive.Root>) {
  return (
    <ToolbarPrimitive.Root
      data-slot="toolbar"
      className={cn(
        "flex h-10 items-center space-x-1 rounded-md border bg-background p-1",
        className,
      )}
      {...props}
    />
  );
}

// Toolbar.displayName = ToolbarPrimitive.Root.displayName;

export {
  Toolbar,
  ToolbarRoot,
  ToolbarSeparator,
  ToolbarToggleGroup,
  ToolbarToggleItem,
};
